var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAndroid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "237px",
    viewBox: "0 0 2048 606",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 5.6843e-14)",
    d: "m0 0h2048v606h-2048z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 5.6843e-14)",
    d: "m0 0h2048v606h-2048zm72 12-16 3-16 8-10 8-9 12-6 13-3 16v462l3 15 5 12 7 10 9 9 13 8 12 4 15 2h1891l15-1 12-3 15-8 12-11 7-11 5-11 2-9 1-9v-456l-2-14-5-14-8-12-10-10-14-8-14-4-6-1z",
    fill: "#A4A4A4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(170 107)",
    d: "m0 0 10 1 12 5 24 14 18 10 24 14 22 12 70 40 25 14 23 13 10 6 1 5-58 58-6 7-8 7-178 178-3-1-4-8-1-4-1-70v-223l1-59 3-8 5-6 7-4z",
    fill: "#00D0FD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(409 237)",
    d: "m0 0 12 6 24 14 22 12 22 13 9 8 4 9v7l-4 9-7 7-26 15-25 14-24 14-22 12-24 14-27 15-46 26-24 14-52 29-24 14-17 8-3 1h-8l-7-3-4-4 185-185h2l2-4 6-6h2l2-4 49-49h2z",
    fill: "#ED354D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1163 329)",
    d: "m0 0h18l10 3 12 7 2 2 1-8h29v121l-2 16-5 15-7 11-5 6-10 7-11 5-8 2-10 1h-10l-12-2-12-5-9-6-9-8-9-14-2-4 8-4 14-6h5l7 11 9 7 10 3h11l9-2 8-5 6-7 4-13 1-16-8 6-10 5-9 2h-15l-12-3-14-7-12-11-8-11-5-10-4-17v-12l4-16 8-16 9-10 8-7 16-8z",
    fill: "#FAFAFA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1476 264)",
    d: "m0 0h73l16 3 16 8 11 9 8 11 5 11 2 7v21l-4 13-5 9-8 10-11 8-10 5-15 4h-49v71l-1 1h-28z",
    fill: "#FCFCFC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(720 257)",
    d: "m0 0 19 1 14 3 13 5 14 8 9 7 4 4-2 4-16 16-4-1-11-8-11-5-16-4h-17l-17 4-15 8-10 8-8 10-8 16-3 11-1 7v15l3 15 6 14 8 11 8 8 11 7 11 5 12 3h24l15-4 13-7 10-9 6-8 4-9 4-15h-65l-1-1v-27l1-1h91l3 2v32l-4 17-5 12-7 12-12 13-15 11-16 7-17 4-6 1h-23l-15-3-12-4-16-8-12-9-10-9-10-13-8-14-6-18-2-11v-23l3-15 6-16 8-14 9-11 10-10 13-9 16-8 16-5z",
    fill: "#FAFAFA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(170 107)",
    d: "m0 0 10 1 12 5 24 14 18 10 24 14 22 12 70 40 25 14 23 13 10 6 1 5-58 58-5 4-7-8-17-17-8-7-15-15v-2h-2l-5-5-12-13-27-27-8-7v-2h-2v-2l-4-2-9-10-67-67-4-3 2-5 5-3z",
    fill: "#00EB7F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1023 329)",
    d: "m0 0h20l16 4 13 7 12 11 7 10 5 11 3 14v15l-2 12-5 12-9 13-10 9-15 8-16 4h-18l-15-4-13-7-10-9-8-9-7-15-3-12v-19l4-14 6-12 8-10 9-8 16-8z",
    fill: "#FAFAFA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(882 329)",
    d: "m0 0h20l13 3 14 7 11 9 8 10 6 12 3 10 1 16-1 12-4 12-6 11-9 11-13 9-14 6-10 2h-18l-12-3-11-5-11-7-7-7-7-10-5-11-3-12v-21l4-14 7-13 11-12 10-7 11-5z",
    fill: "#FAFAFA"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1714 328)",
    d: "m0 0h12l16 3 16 8 9 8 7 11 4 13v83l-1 1h-27l-1-1v-12l-7 8-14 7-9 2h-12l-13-3-11-6-9-8-6-10-3-10v-11l4-12 6-8 10-9 13-6 7-2 8-1h14l12 2 10 4-2-9-4-6-10-6-8-2h-10l-10 3-7 6-3 4-9-3-15-6-2-4 8-11 8-7 12-6 11-3z",
    fill: "#FAFAFA"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(409 237)",
    d: "m0 0 12 6 24 14 22 12 22 13 9 8 4 9v7l-4 9-7 7-26 15-25 14-24 14-6 2-62-62-3 1 2-4 6-6h2l2-4 49-49h2z",
    fill: "#FECA0E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1346 329)",
    d: "m0 0h20l13 4 12 7 11 11 8 13 5 11-1 4-38 16-39 16-7 3 6 9 9 6 6 2h16l11-4 10-9 2-3 5 1 11 8 7 4-1 5-9 10-11 8-11 5-13 3h-18l-15-4-13-7-10-9-6-7-8-16-3-12v-21l3-13 6-12 8-11h2v-2l12-9 12-5z",
    fill: "#FAFAFA"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(68 594)",
    d: "m0 0h1912v1l-15 1-2 2-9 1-361 1h-1260l-249-1-11-2-6-1z",
    fill: "#B3B6B8"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1779 333)",
    d: "m0 0h32l5 12 17 41 11 27 5-12 14-35 12-31 2-2h33l-10 23-18 41-16 37-11 25-13 30-10 23-1 1h-30l-1-2 11-23 16-36 1-6-20-45-18-41-11-25z",
    fill: "#FAFAFA"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1497 102)",
    d: "m0 0h17l9 2 11 6 9 8 7 11 4 11 1 6v10l-2 11-7 14-7 8-12 8-13 4h-17l-10-3-11-6-10-10-8-16-1-4v-21l4-11 6-10 5-6 10-7 10-4z",
    fill: "#F8F8F8"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(930 102)",
    d: "m0 0h16l12 3 11 7 8 8 6 10 4 13v17l-4 13-7 11-7 7-12 7-11 3h-17l-12-4-11-7-9-10-5-10-3-10v-17l5-15 8-11 9-8 13-6z",
    fill: "#F8F8F8"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(625 104)",
    d: "m0 0h38l12 3 8 4 10 9 7 11 3 10v20l-4 12-6 10-7 7-14 7-9 2h-38z",
    fill: "#F8F8F8"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1622 264)",
    d: "m0 0h28l1 1v189l-1 1h-28l-1-1v-189z",
    fill: "#F7F7F7"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1253 264)",
    d: "m0 0h29v190l-1 1h-28l-1-3v-187z",
    fill: "#FAFAFA"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1030 355)",
    d: "m0 0h7l13 4 9 7 6 8 3 7 1 6v14l-4 13-7 9-9 6-9 3h-14l-12-5-10-10-5-11-1-4v-16l4-12 7-9 8-6 8-3z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(888 355)",
    d: "m0 0h8l10 3 10 6 7 9 4 9 1 6v11l-2 9-5 10-8 8-8 4-6 2h-14l-12-5-7-6-6-9-3-9v-19l5-12 9-10 9-5z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1372 104)",
    d: "m0 0h18l14 23 24 38 2 3v-64h16v95h-16l-12-19-30-48-1 67h-15l-1-1v-93z",
    fill: "#F7F8F8"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(999 104)",
    d: "m0 0h18l7 10 10 17 15 23 8 13v-18l1-45h16v94l-1 1h-15l-11-17-30-48-1-2-1 67h-16z",
    fill: "#F9F9F9"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1171 355)",
    d: "m0 0h7l10 3 9 6 7 10 4 12v16l-3 10-5 8-7 7-12 5h-14l-12-5-9-9-5-10-2-9v-10l3-11 5-9 5-6 14-7z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1505 292)",
    d: "m0 0h44l9 2 8 5 7 8 4 9v16l-5 10-5 6-10 6-8 2h-44z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(820 104)",
    d: "m0 0h41l10 4 8 7 4 8 2 7-1 11-5 10-7 6-8 4-4 1h-23v36l-1 1h-15l-1-1z",
    fill: "#F6F7F7"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(933 117)",
    d: "m0 0h10l12 4 9 8 5 9 2 10v9l-3 11-7 9-9 6-5 2h-17l-8-3-9-7-5-8-2-6-1-11 2-11 4-8 6-7 6-4z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1501 117)",
    d: "m0 0h10l11 4 8 6 6 10 3 13-2 13-5 10-7 7-7 4-4 1h-17l-12-6-7-8-4-9-1-5v-11l2-9 6-9 8-7 7-3z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1204 104)",
    d: "m0 0h57v15h-41v25h37v14l-1 1h-36v25l8-1h32l1 1v15h-57l-1-69v-21z",
    fill: "#F8F8F8"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(768 102)",
    d: "m0 0h14l9 3 8 6 6 9 1 3-14 7-6-9-6-3h-9l-7 4-2 4 1 6 4 4 12 5 14 6 9 7 4 6 2 5v15l-4 8-4 5-8 5-10 3h-13l-10-4-6-4-7-7-4-9 1-5 11-5h2l6 12 8 5h13l6-4 2-4-1-10-8-6-19-7-10-6-5-6-3-7v-12l4-8 5-5 9-6z",
    fill: "#F8F8F8"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1113 104)",
    d: "m0 0h17l3 8 18 53 2 7 4-9 10-29 10-28 1-2h17l-2 9-19 52-11 30-2 4h-15l-5-12-20-57-8-23z",
    fill: "#F8F8F8"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(641 119)",
    d: "m0 0h18l9 2 8 4 7 8 3 7 1 7v9l-2 10-5 8-6 5-10 4-23 1z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1275 104)",
    d: "m0 0h16l1 79h37l2 1v14l-1 1h-54l-1-1z",
    fill: "#F6F6F6"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(10 92)",
    d: "m0 0h1l1 435 1 7v10l-2-3-1-2-1-22h-1l-1-15v-392z",
    fill: "#B3B6B8"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(715 104)",
    d: "m0 0h16l1 94-1 1h-16z",
    fill: "#FBFBFB"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1091 104)",
    d: "m0 0h15v95h-15l-1-1v-93z",
    fill: "#F3F4F4"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1721 397)",
    d: "m0 0 16 1 11 4 1 1-1 8-6 10-7 6-8 4-4 1h-13l-9-4-5-6-1-8 3-7 5-5 10-4z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2047 542)",
    d: "m0 0h1v64h-65v-1l17-5 14-7 11-9 8-9 7-12 5-14z",
    fill: "#c35722"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 543)",
    d: "m0 0 2 4 6 16 7 12 11 12 10 7 14 7 14 4v1h-64z",
    fill: "#c35722"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1985 5.6843e-14)",
    d: "m0 0h63v64l-2-4-5-15-6-11-8-10-10-9-14-8-18-6z",
    fill: "#c35722"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 5.6843e-14)",
    d: "m0 0h63l-4 2-14 5-13 7-12 11-8 10-7 15-4 13h-1z",
    fill: "#c35722"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2036 68)",
    d: "m0 0 2 4 1 4 1 32v321l-1 69h-2z",
    fill: "#B4B7B9"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1352 355)",
    d: "m0 0h12l9 4 5 4 2 5-14 6-41 17-1-4 3-12 6-9 7-6z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(837 119)",
    d: "m0 0h18l7 2 5 5 1 3v8l-4 6-4 3-4 1h-19z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1099 80)",
    d: "m0 0h17l-2 5-9 16h-14l-1-2 7-17z",
    fill: "#F3F3F3"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(10 527)",
    d: "m0 0h2l1 7v10l-2-3-1-2z",
    fill: "#B1B3B5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroid);
export default __webpack_public_path__ + "static/media/android.0389b89ae2bd579e8948f053b5f394de.svg";
export { ForwardRef as ReactComponent };